import { render } from "./ProyectosPorPersonal.vue?vue&type=template&id=6e1df402"
import script from "./ProyectosPorPersonal.vue?vue&type=script&lang=js"
export * from "./ProyectosPorPersonal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__